import { Count } from '@/features/events';
import React, { useEffect, useState } from 'react';
import './Tab.scss';
import { Dropdown } from 'react-bootstrap';
import { ReactComponent as DownArrow } from '@/assets/img/down-arrow.svg';
import { useTranslation } from 'react-i18next';

type TabProps = {
  onChange: (item: number) => void;
  selectedTabIndex: number;
  tabs: any[];
  appointmentsCount?: Count | undefined;
  responsive?: boolean;
  mode?: keyof typeof modes;
  isOnlyLabel?: boolean;
  isroomBooking?: boolean;
};
const modes = {
  tab: 'tab',
  dd: 'dd',
  tabIcon: 'tabIcon',
};
export const Tabs = ({
  onChange,
  selectedTabIndex,
  tabs,
  appointmentsCount,
  responsive = true,
  mode = 'tab',
  isOnlyLabel,
  isroomBooking,
}: TabProps) => {
  const [selectedIndex, setSelectedIndex] = useState<number>(0);
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (selectedTabIndex >= 0) {
      setSelectedIndex(selectedTabIndex);
    }
  }, [selectedTabIndex]);
  const onTabClicked = (index: number) => {
    if (index != selectedIndex) {
      if (!tabs[index]?.disabled) {
        setSelectedIndex(index);
        onChange(index);
      } else {
        onChange(selectedIndex);
      }
    }
  };
  const selectedTab = tabs[selectedIndex];
  return (
    <>
      {(mode === 'tab' || mode === 'tabIcon') && (
        <div
          className={`horizontal-tab ${mode} ${responsive ? 'responsive' : 'no-responsive'} ${
            isroomBooking ? 'rooms-tab' : ''
          }`}
        >
          {tabs.map((tab, index) => (
            <>
              {tab.show && (
                <div
                  className={`tab-item ${index == selectedIndex ? 'active' : ''} ${
                    isOnlyLabel ? 'only-label' : ''
                  } ${tab.disabled ? 'disabled' : ''}`}
                  onClick={() => onTabClicked(index)}
                >
                  {tab.icon ? (
                    <img src={index == selectedIndex ? tab.icon : tab.selectedIcon} />
                  ) : (
                    tab?.label
                  )}
                  {tab?.label == 'Requested' && (
                    <div className="pet-badge-rounded">{appointmentsCount?.requested}</div>
                  )}
                </div>
              )}
              {mode != 'tabIcon' && tab.show && index < tabs.length - 1 && (
                <div className="menu-divider"></div>
              )}
            </>
          ))}
        </div>
      )}
      <Dropdown className={`tab-dropdown ${mode} ${responsive ? 'responsive' : 'no-responsive'}`}>
        <Dropdown.Toggle
          variant="success"
          className="drop-down-btn dropdown-toggle btn btn-success"
          id="dropdown-basic"
        >
          <span className="button-label">
            {selectedTab && selectedTab?.label}
            {selectedTab?.label == 'Requested' && (
              <span className="requested-count">
                <span>{appointmentsCount?.requested}</span>
              </span>
            )}
          </span>
          <DownArrow className="down-arrow" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {tabs &&
            tabs?.map((tab, index) => {
              return tab.show ? (
                <Dropdown.Item
                  key={`dropdown-item-${index}`}
                  onClick={() => {
                    onTabClicked(index);
                  }}
                >
                  {t(tab.label)}
                </Dropdown.Item>
              ) : (
                <></>
              );
            })}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};
